import "./aiDoctorVideoSection.scss";
import React, { useRef, useState } from "react";

 const AiDoctorVideoSection = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
  
    const handlePlayPause = () => {
      if (videoRef.current) {
        if (isPlaying) {
          videoRef.current.pause();
        } else {
          videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
      }
    };
  return (
    <div className="ai-video-container">
      <div className="ai-video-wrapper max-w-[1500px] m-auto">
        <div className="video-parent bg-slate-500">
        <video
            ref={videoRef}
            src="https://truvitawellness.com/-e023-422f-a4d0-b4c55449519c.mp4"
            className="video-element"
            playsInline
            onClick={handlePlayPause}
          >
            Your browser does not support the video tag.
          </video>
          {!isPlaying && (
            <button
              className="play-button"
              onClick={handlePlayPause}
              aria-label="Play Video"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
              >
                <path
                  d="M74 36.5359C76.6667 38.0755 76.6667 41.9245 74 43.4641L26 71.1769C23.3333 72.7165 20 70.792 20 67.7128L20 12.2872C20 9.20799 23.3333 7.28348 26 8.82308L74 36.5359Z"
                  fill="white"
                  fill-opacity="0.7"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};



export default AiDoctorVideoSection;